import { render, staticRenderFns } from "./DragAndDropUpload.vue?vue&type=template&id=2573551a&scoped=true"
import script from "./DragAndDropUpload.vue?vue&type=script&lang=js"
export * from "./DragAndDropUpload.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropUpload.vue?vue&type=style&index=0&id=2573551a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573551a",
  null
  
)

export default component.exports